import { BaseStore } from "./base_store";
import { makeAutoObservable, runInAction } from "mobx"
import UserAPI from "api/user";
import { api_get, api_post } from "api/utils";

export type RoleProps = {
	key: string;
	user: string;
	role: string;
	date_created: string;
	updateProps: (attributes: RoleProps) => void;
};

// Domain object Role
export class Role implements RoleProps {

	key = "";
	user = "";
	role = "";
	date_created = "";

	constructor(attributes: RoleProps) {
		makeAutoObservable(this, {
			updateProps: false
		})
		if(attributes) {
			this.updateProps(attributes);
        }
	}

	updateProps(attributes: RoleProps) {
		runInAction(() => {
			Object.assign(this, attributes);
		})
		//		Object.assign(this, attributes);
	}

}


export class RoleStore extends BaseStore<RoleProps, Role> {

	getUserRoles(userKey: string) {
        const ret = this.items.slice().filter((c) => c.user == userKey)
        return ret;
	}

    getUserRolesNames(userKey: string) {
        if(userKey) {
            return this.getUserRoles(userKey).map((r) => r.role)
        }
    }

	async  fetchAllRoles() {
		return UserAPI.loadUserRoles().then((json) => {
			this.receiveUpdate(json);
		})
	}

	async sudoGrant(userKey: string, roleName: string): Promise<RoleProps[]>{
        const data = { user: userKey, role: roleName }
        return api_post(`/role/grant`, data).then((resp) => {
            return resp.json();
		})
	}

	async sudoRevoke(userKey: string, roleName: string): Promise<RoleProps[]>{
        const data = { user: userKey, role: roleName }
        return api_post(`/role/revoke`, data).then((resp) => {
            return resp.json();
		})
	}

	async sudoList(userKey: string): Promise<RoleProps[]>{
        const data = { user: userKey }
        return api_get(`/role/list`, data).then((resp) => {
            return resp.json();
		})
	}


	modelConstructor() {
		return Role;
	}

}
